import API from '@/common/modules/api'
import Messages from '@/common/configs/messages'

const limit = 20;

const defaults = {
    columns: [
        'building.type',
        'dealtAt',
        'building.name',
        'building.address',
        'dealPrice',
        'done',
        'sqm',
        'landSqm',
        'floorPlan',
        'floor',
        'roomNumber',
        'building.builtAt'
    ]
};

export default {

    namespaced: true,

    state: {
        deals: [],
        total: 0,
        all: false,
        selected: [],
        columns: defaults.columns,
        loaded: false,
        request: null
    },

    getters: {

        bulk (state) {
            return state.all || state.selected.length;
        },

        count (state) {
            return state.all ?
                state.total - state.selected.length :
                state.selected.length;
        }

    },

    mutations: {

        select (state, id) {
            const i = state.selected.indexOf(id);
            i > -1 ? state.selected.splice(i, 1) : state.selected.push(id);
        },

        selectall (state) {
            state.all = !state.all;
            state.selected.splice(0);
        },

        clear (state) {
            state.selected.splice(0);
        }

    },

    actions: {

        abort ({state}) {
            state.request && API.abort(state.request);
        },

        list ({state, rootGetters, dispatch}, refresh = false) {
            const query = {
                ...rootGetters['search/params'],
                limit: state.limit,
                skip: refresh ? 0 : state.deals.length
            };
            return state.request || (state.request = API('deals', query))
                .then(response => {
                    const data = response.data;
                    if (!('count' in data)) {
                        return dispatch('toasts/error', Messages.serverError, {root: true});
                    }
                    state.deals = refresh ?
                        data.deals : state.deals.concat(data.deals);
                    state.total = data.count;
                    state.loaded = data.deals.length < limit;
                })
                .finally(() => {
                    state.request = null;
                })
        },

        del ({state, commit}, id) {
            const ids = id ? [id] : state.selected;
            return API('delete', ids, state.all)
                .then(() => {
                    if (state.all) {
                        state.deals = state.deals.filter(deal => ids.includes(deal.id));
                        state.selectall();
                        state.loaded = true;
                    } else {
                        ids.forEach(id => {
                            const i = state.deals.findIndex(deal => deal.id === id);
                            state.deals.splice(i, 1);
                            const j = state.selected.indexOf(id);
                            if (j > 0) state.selected.splice(j, 1);
                        });
                    }
                    commit('clear');
                });
        }

    }

}
